import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output } from "@angular/core";
import { DisplayType, Roles } from 'src/app/utils'
import { EmployeeService } from 'src/app/services/employee.service'
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from "@angular/router";
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'ert',
  templateUrl: './ert.component.html',
  styleUrls: ['./ert.component.scss']
})
export class ErtComponent {
  @Input() list //Employee model to be added
  members: any = [
    {
      id: 0,
      memberNo: 1,
    },
  ];
  name: boolean;
  mobile: boolean;
  email: boolean;
  fieldErrors: any[];
  ertCount: number = 0;
  displayType = DisplayType
  openOptionDrawer: boolean;
  adminCount: number = 0;
  Form: FormGroup;
  isLoaded: boolean = false
  selectedUsers: any[] = []
  ertMember = 10
  coAdminCount: number = 0;
  isChecked = false
  submitted = false
  checkboxValue: boolean = false;
  parkAdmin = 7
  parkTenantId: any;
  userId = localStorage.getItem('userId')
  @Output()
  refreshDataErt = new EventEmitter<any>();
  @Output()
  searchResult = new EventEmitter<any[]>();

  emailCheck: any[] = ['a']
  emailDisplay = '@sharma.com'
  emailDomains = JSON.parse(localStorage.getItem('companyEmailDomain'));
  selectedEmail: any[] = []
  dotDropDownDetail: any
  companyAdd: any;

  parTenantId: any;
  selectedBuidling: any[] = [];
  empTypes: any = [{ name: 'All', image: '', checked: false, id: 1 }, { name: 'Verified', image: 'assets/images/company/verified_user.png', checked: false, id: 2 }, { name: 'Non-verified', image: 'assets/images/company/verified_user_pending.png', checked: false, id: 3 }];
  inviteRights: any = [{ name: 'All', checked: false, id: 1 }, { name: 'With Rights', checked: false, id: 2 }, { name: 'Without Rights', checked: false, id: 3 }, { name: 'Pending Approval', checked: false, id: 5 }];
  page = 1;
  pageSize = 50;
  totalCount = 0
  noPages = 1;
  parkId = (localStorage.getItem('parkId')) ? localStorage.getItem('parkId') : null;
  isLoadData = false;
  private skipNgOnChanges = false;
  employeeCount: number = 0;
  searchText = '';
  parkBuilding: any[] = [];
  newList = [];

  @HostListener('click', ['$event'])
  captureClick(event) {
    this.dotDropDownDetail = undefined
    if (event.target.className !== 'drawer-container') {
      this.openOptionDrawer = false;
    }
  }


  constructor(private fb: FormBuilder,
    private employeeService: EmployeeService,
    private activateRoute: ActivatedRoute,
    private rolebasedactionService: RolebasedactionService,
  ) {
    this.parkTenantId = this.activateRoute.snapshot.params.id;
  }

  ngOnInit() {
    this.companyAdd = this.rolebasedactionService.checkUserRolePermissionExits('Company:Create');
    this.filterERT(this.list);
    this.createform();
    this.emailCheck[0] = 'a'
    this.selectedEmail[0] = this.emailDomains[0];
    this.getBuildingsByParkId();
  }

  ngOnChanges() {
    if (this.skipNgOnChanges) {
      this.skipNgOnChanges = false;
      return;
    }
    this.filterERT(this.list);
  }

  async createform() {
    // this.Form = this.fb.group({
    //   users: this.fb.array([this.fb.group({
    //     name: ['', Validators.required],
    //     phoneNumber: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
    //     email: ['', [Validators.required]],
    //     // parkUserId: '69AA3BA5-D51E-465E-8447-ECAA1939739A',
    //     parkTenantId: this.parkTenantId,
    //     employeeRole: 'ERT',
    //     employeeType: 'ParkiteWhitelisted',
    //     // userId: 240
    //   })])
    // })

    this.Form = this.fb.group({
      users: this.fb.array([])
    })
    this.isLoaded = true;
    // if(this.ertCount == 0) {
    //   this.addMember()
    // }

  }

  get users() {
    return this.Form.get('users') as FormArray;
  }

  enterName(field) {
    if (field == 'name') {
      this.name = !this.name;
      // if (this.fullpropertyType1.length != 0) {
      // this.name = true;
      // }
    }
    if (field == 'mobile') {
      this.mobile = !this.mobile;
      // if (this.fullpropertyType1.length != 0) {
      // this.name = true;
      // }
    }
    if (field == 'email') {
      this.email = !this.email;
      // if (this.fullpropertyType1.length != 0) {
      // this.name = true;
      // }
    }
  }
  inputModelChange(adminNumber: number, type: string) {
    // this.textToLowercase(adminNumber);
    // const formStatus = this.formValidator(adminNumber, type);
    this.fieldErrors = [];
    // if (!formStatus.valid)
    // this.fieldErrors = formStatus.errFields;
    console.log('fields errors', this.fieldErrors);
  }

  revokeAccess() {
    let payload = {
      useridList: this.selectedUsers,
      roleId: this.ertMember
    }
    this.employeeService.revokeEmployeeRights(payload).subscribe(res => {
      console.log(res);
    });
  }

  /// new api to be provided
  markAsAdmin($event = undefined) {
    console.log($event);
    let payload = {}
    if ($event !== undefined) {
      payload = {
        useridList: [$event.id],
        roleId: this.parkAdmin
      }
    } else {
      payload = {
        useridList: this.selectedUsers,
        roleId: this.parkAdmin
      }
    }
    this.employeeService.markAsAdmin(payload).subscribe(res => {
      console.log(res);
      this.refreshDataErt.emit()
    });
  }

  // onItemChange(event: any) {
  //   // radio button
  //   console.log(event);
  // }
  addMember() {
    this.emailCheck[this.users.length] = ['a']
    this.selectedEmail[this.users.length] = this.emailDomains[0]
    this.users.push(this.fb.group({
      name: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?^[6789][0-9]{9}$")]],
      email: ['', [Validators.required]],
      // parkUserId: '69AA3BA5-D51E-465E-8447-ECAA1939739A',
      parkTenantId: this.parkTenantId,
      employeeRole: 'ERT',
      employeeType: 'ParkiteWhitelisted',
      // userId: 240
    }));
    const data = {
      id: 0,
      memberNo: this.members.length + 1,
    };

    this.members.push(data);
  }

  removeMember(id) {
    this.members.forEach((item, index) => {
      if (item.memberNo == id) this.members.splice(index, 1);
    });
  }

  //filter admins and coadmins from employee array
  filterERT(employees: any[]) {
    console.log(employees);
    if (employees != null && employees.length > 0) {
      this.ertCount = 0;
      this.list = employees.filter(res => {
        if (res.employeeRole == Roles.ERT && res.isActive && res.isVerified) {
          this.ertCount++;
          return res
        }
      });
    }

  }

  getSelectedUser(event) {
    console.log(event);
    if (event.checked) {
      this.selectedUsers.push(event.id);
    } else {
      var index = this.selectedUsers.indexOf(event.id);
      this.selectedUsers.splice(index, 1);
    }
    this.isChecked = (this.ertCount == this.selectedUsers.length) ? true : false
    console.log(this.coAdminCount);
    console.log(this.selectedUsers);
  }

  SaveData() {
    console.log(this.Form.value.users);
    this.submitted = true
    if (this.Form.invalid)
      return;

    let payload = []
    for (let i = 0; i < this.users.length; i++) {
      let payloadData = {
        name: this.users.controls[i]['value'].name,
        phoneNumber: '+91' + this.users.controls[i]['value'].phoneNumber,
        email: (this.emailCheck[i] == 'a') ? this.users.controls[i]['value'].email + this.selectedEmail[i] : this.users.controls[i]['value'].email,
        parkTenantId: this.parkTenantId,
        employeeRole: 'ERT',
        createdby: this.userId
      }
      payload.push(payloadData);
    }

    this.employeeService.saveEmployees(payload).subscribe(res => {
      console.log(res);
      this.Form.reset()
      this.refreshDataErt.emit();
      this.users.controls = []
    });
  }

  removeCoadmin(id) {
    this.users.removeAt(id);
    this.members.forEach((item, index) => {

      if (item.coadminNo == id) this.members.splice(index, 1);
    });
  }

  selectDeselectUsers() {
    this.isChecked = !this.isChecked
    this.checkboxValue = this.isChecked
    this.selectedUsers = [];
    if (this.isChecked) {
      this.list.filter(res => {
        if (res.isRegistered) {
          this.selectedUsers.push(res.userId);
        }
      });
    }
    console.log(this.selectedUsers);
  }

  onItemChange(event, i) {
    // console.log((this.companyOfficalEmailId.controls[0]['controls']['officalEmail'].value).split('@')[1]);
    // this.emailDisplay = '@'+ (this.companyOfficalEmailId.controls[0]['controls']['officalEmail'].value).split('@')[1]
    // this.emailDisplay = '@sharma.com'
    this.emailCheck[i] = event
    // this.users.get('email').addValidators(Validators.email);
    if (event == 'b') {
      console.log(this.users.controls[0]['controls']['email']);
      this.users.controls[i]['controls']['email'].setValidators([Validators.email, Validators.required]);
    } else {
      this.users.controls[i]['controls']['email'].setValidators([Validators.required]);
    }
    this.users.controls[i]['controls']['email'].updateValueAndValidity();
  }

  clearBoxes() {
    for (let i = this.users.length; i >= 0; i--) {
      this.users.removeAt(i)
    };
  }

  selectedEmailDomain(i, value) {
    console.log(value)
    console.log(i)
    this.selectedEmail[i] = value
    console.log(this.selectedEmail)
  }

  handlePageChange(event) {
    this.page = event;
    this.getEmployeeByFilter()
  }

  closeAllTabs() {
    this.openOptionDrawer = false;
    this.dotDropDownDetail = undefined
  }

  getEmployeeByFilter() {
    this.closeAllTabs();
    let payload = {
      "parkTenantId": this.parkTenantId,//"B8657E8D-C137-46A4-9DE0-BDBB01B8FC04",
      "buildingName": this.selectedBuidling,
      "verified": (this.empTypes[1].checked) ? false : true,
      "nonverified": (this.empTypes[2].checked) ? false : true,
      "withRights": (this.inviteRights[1].checked) ? false : true,
      "withOutrights": (this.inviteRights[2].checked) ? false : true,
      "pendingApproval": (this.inviteRights[3].checked) ? false : true,
      // "deactive": this.deactive,
      // "block": this.block,
      "pageNo": this.page,
      "size": this.pageSize,
      "deactive": false,
      "searchTerm": this.searchText,
      "parkId": this.parkId,
      "actionUserCategory": "ERT"
    }
    this.employeeService.getEmployeeListByFilter(payload).subscribe(res => {
      if (res.isValid) {
        console.log(res.data.employees);
        this.totalCount = res.data.count;
        this.ertCount = res.data.count;
        this.noPages = Math.ceil(this.totalCount / this.pageSize);
        this.filterActiveEmployee(res.data.employees);
        this.list = res.data.employees;
        this.newList = res.data.employees;
        this.isLoadData = true;
        this.skipNgOnChanges = true;
        this.searchResult.emit(res.data.employees);
      } else {
        this.isLoadData = true
      }
    });
  }

  filterActiveEmployee(employees: any[]) {
    employees.filter(res => {
      if (res.isActive && res.employeeRole !== Roles.ParkAdmin) {
        this.employeeCount++;
      }
    });
  }

  getBuildingsByParkId() {
    this.employeeService.getBuildingByParkIdAndTenatID(this.parkId, this.parkTenantId).subscribe(res => {
      this.selectedBuidling = res.list.map((item: any) => item.parkBuildingName);
    });
  }
}
